import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";
import "./Edit.css";
import { Link, useLocation, useParams } from "react-router-dom";
import { Button, Input, notification, Space } from "antd";
import { imoService } from "../../../services";
import { changeDocumentTitle } from "../../../utils/title";

export const ImoEdit = () => {
  const { id } = useParams();
  const location = useLocation();
  const isAdd = location.state?.isAdd || false;
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(true)

  // State to manage all input values
  const [formData, setFormData] = useState({
    shipper: "",
    transportation_no: "",
    booking_no: "",
    shipper_references: "",
    consignee: "",
    forwarder_refernece: "",
    vessel: "",
    place_of_handling: "",
    place_of_delivery: "",
    instructions: "",
    description: "",
    weight: "",
    ctu_id: "",
    seal_no: "",
    ctu_size: "",
    tare_mass: "",
    total_gross_mass: "",
    name_of_company: "",
    haulers_name: "",
    name_of_company_preparing_note: "",
    name_status_declarant_note_2: "",
    vehicle_registration_no: "",
    place_and_date_1: "",
    place_and_date_2: "",
    driver_name_and_date: "",
    name_status_declarant_note_1: "",
  });

  // Update the state for a specific field
  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  // Handle the Update button click
  const handleUpdate = async () => {
    setLoading(true);
    const response = isAdd ? await imoService.addIMO(formData) : await imoService.updateIMO(id, formData);
    setLoading(false);
    if (response.success) {
      notification.success({
        message: "Updated Successfully!",
        description: response.message,
        placement: "topRight",
      });
    }
  };

  const initialize = async (isEditMode) => {
    const response = isEditMode ? await imoService.viewIMO(id) : await imoService.addDetails(id)
    if (response.success) {
      isEditMode ? setFormData({ ...response.data }) : setFormData((prevData) => ({
        ...prevData,
        shipper: response.data.customers.map((cust) => cust.name).join(" / "),
        booking_no: response.data.container.c_booking_number,
        transportation_no: response.data.container.c_booking_number,
        forwarder_refernece: "GLOBEX SHIPPING USA.\n 4750 E MOODY BLVD SUIT- 214,, BUNNELL, FL 32110",
        name_of_company: "CTRADE USA INC",
        haulers_name: "H LOGISTICS USA LLC",
        name_of_company_preparing_note: "CTRADE USA INC",
        place_of_delivery: "HOUSTON,TX",
        description: response.data.customers.map((v) => v.vehicles
          .map((v) => {
            // If any of the fields (code, name, class) are missing, show "NON DG" once
            const isNonDG = !v.code && !v.name && !v.class;
            return `${v.year} ${v.vehicle} VIN ${v.chasis_no} \n ${isNonDG ? "NON DG" : `${v.code}  ${v.name} ${v.class}`
              }`;
          })
          .join("\n")).join('\n\n'),
        weight: response.data.customers.map((v) => v.vehicles.map((v) => v.weight).join("\n")).join("\n\n"),
        ctu_id: response.data.container.c_container_number,
        seal_no: response.data?.sealnumber?.seal_number ?? 'N/A'
      }))
    }
  };

  useEffect(() => {
    changeDocumentTitle(!isAdd ? " Edit IMO" : " Add IMO");
    // console.log(isAdd ? "add" : "edit");

    setIsEdit(!isAdd);
    initialize(!isAdd);
  }, [isAdd]);


  // useEffect(() => {
  //   document.title = !isAdd ? "CTrade - Edit IMO" : "CTrade - Add IMO";
  //   if (!isAdd) {
  //     console.log("edit")
  //     setIsEdit(true)
  //     initialize();
  //   } else {
  //     console.log("add")
  //     setIsEdit(false)
  //     initialize(false)
  //   }
  // }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: 20,
      }}
    >
      <div className="container" style={{ backgroundColor: "#FFFFFF" }}>
        <h4 className="imo-heading">IMO DANGEROUS GOODS DECLARATION</h4>
        <div className="topOne">
          <div className="topOne-left">
            <h5> 1. Shipper</h5>
            <TextArea
              value={formData.shipper}
              onChange={(e) => handleInputChange("shipper", e.target.value)}
            />
          </div>
          <div className="topOne-right">
            <h5>2. Transportation Document Number <span className="text-red-500">(Editable through loading plan)</span></h5>
            <Input
              value={formData.transportation_no}
              onChange={(e) =>
                handleInputChange("transportation_no", e.target.value)
              }
              readOnly
            />
            <div className="topOne-right-inner">
              <div>
                <h5>3. Carrier</h5>
                <Input
                  readOnly
                  value={formData.booking_no}
                  onChange={(e) =>
                    handleInputChange("booking_no", e.target.value)
                  }
                />
              </div>
              <div>
                <h5>4. Shipper References</h5>
                <Input
                  value={formData.shipper_references}
                  onChange={(e) =>
                    handleInputChange("shipper_references", e.target.value)
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="topTwo">
          <div className="topTwo-left">
            <h5>6. Consignee</h5>
            <TextArea
              value={formData.consignee}
              onChange={(e) => handleInputChange("consignee", e.target.value)}
            />
          </div>
          <div className="topTwo-right">
            <h5>5. Freight Forwarder's Reference</h5>
            <TextArea
              value={formData.forwarder_refernece}
              onChange={(e) =>
                handleInputChange("forwarder_refernece", e.target.value)
              }
            />
            <h5>7. Carrier (to be declared by the Carrier)</h5>
            <Input
              value={formData.carrier_name}
              onChange={(e) =>
                handleInputChange("carrier_name", e.target.value)
              }
            />
          </div>
        </div>
        <div className="topThree">
          <div>
            <h5> SHIPPER'S DECLARATION </h5>
            <p>
              I hereby declare that the contents of this consignment are fully
              and accurately described above by the proper shipping name(s), and
              are classified, packaged, marked and labeled/placarded, and are in
              all respects in proper condition for transport according to
              applicable international and national governmental regulations
            </p>
          </div>
        </div>
        <div className="topFour">
          <div className="topFour-left">
            <h5>10. Vessel/Flight and Date</h5>
            <Input
              value={formData.vessel}
              onChange={(e) => handleInputChange("vessel", e.target.value)}
            />
            <div className="topFour-right-inner">
              <div>
                <h5>11. Port/Place Handling</h5>
                <Input
                  value={formData.place_of_handling}
                  onChange={(e) =>
                    handleInputChange("place_of_handling", e.target.value)
                  }
                />
              </div>
              <div>
                <h5>Port/Place Delivery</h5>
                <Input
                  value={formData.place_of_delivery}
                  onChange={(e) =>
                    handleInputChange("place_of_delivery", e.target.value)
                  }
                />
              </div>
            </div>
          </div>
          <div className="topFour-right">
            <h5>9. Additional Handling Information</h5>
            <TextArea
              value={formData.instructions}
              onChange={(e) =>
                handleInputChange("instructions", e.target.value)
              }
              rows={4}
            />
          </div>
        </div>
        {!isAdd && <div className="topFive-container ">
          {/* Header Row */}
          <div className="topFive-header ">
            <div className="topFive-left-heading"><h5>14. Shipping Marks</h5></div>
            <div className="topFive-center-heading"><h5>Number and Kind of Packages, Description of Goods</h5></div>
            <div className="topFive-right-heading"><h5>GW (kg)</h5></div>
          </div>

          {/* Rows for Vehicles */}
          {isEdit ?
            <div className="topFive-row">
              <div className="topFive-left ">
              </div>
              <div className="topFive-center">
                <TextArea
                  value={formData.description}
                  // onChange={(e) => handleInputChange(index, "description", e.target.value)}
                  rows={3}
                />
              </div>
              <div className="topFive-right">
                <TextArea
                  value={formData.weight}
                  // onChange={(e) => handleInputChange(index, "weight", e.target.value)}
                  rows={3}
                />
              </div>
            </div>
            :
            (formData?.customers?.map((customer, index) => (
              <div className="topFive-row" key={index}>
                <div className="topFive-left ">
                </div>
                <div className="topFive-center">
                  <TextArea
                    value={customer.vehicles
                      .map((v) => {
                        // If any of the fields (code, name, class) are missing, show "NON DG" once
                        const isNonDG = !v.code && !v.name && !v.class;
                        return `${v.year} ${v.vehicle} VIN ${v.chasis_no} \n ${isNonDG ? "NON DG" : `${v.code}  ${v.name} ${v.class}`
                          }`;
                      })
                      .join("\n")}
                    onChange={(e) => handleInputChange(index, "description", e.target.value)}
                    rows={3}
                  />
                </div>
                <div className="topFive-right">
                  <TextArea
                    value={customer.vehicles.map((v) => v.weight).join("\n")}
                    onChange={(e) => handleInputChange(index, "weight", e.target.value)}
                    rows={3}
                  />
                </div>
              </div>
            )))}
        </div>}
        {isAdd && <div className="topFive ">
          <div className="topFive-left">
            <h5>14. Shipping Marks </h5>
            <div className="seperator"></div>
          </div>
          <div className="topFive-center">
            <h5>Number and Kind of Packages, Description of Goods </h5>
            <div className="seperator"></div>
            <TextArea
              value={formData.description}
              onChange={(e) => handleInputChange("description", e.target.value)}
              rows={4}
            />
          </div>

          <div className="topFive-right">
            <h5>GW (kg)</h5>
            <div className="seperator"></div>
            <TextArea
              value={formData.weight}
              onChange={(e) => handleInputChange("weight", e.target.value)}
              rows={4}
            />
          </div>
        </div>}
        <div className="topSix">
          <div className="topSix-inner">
            <h5>15 CTU ID No. <span className="text-red-500">(Editable through loading plan)</span></h5>
            <Input
              value={formData.ctu_id}
              onChange={(e) => handleInputChange("ctu_id", e.target.value)}
              rows={4}
              readOnly
            />
          </div>
          <div className="topSix-inner">
            <h5>16 Seal No. <span className="text-red-500">(Editable through loading plan)</span></h5>
            <Input
              value={formData.seal_no}
              onChange={(e) => handleInputChange("seal_no", e.target.value)}
              rows={4}
              readOnly
            />
          </div>
          <div className="topSix-inner">
            <h5>17 CTU Size and Type</h5>
            <Input
              value={formData.ctu_size}
              onChange={(e) => handleInputChange("ctu_size", e.target.value)}
              rows={4}
            />
          </div>
          <div className="topSix-inner">
            <h5>18 Tare Mass (kg)</h5>
            <Input
              value={formData.tare_mass}
              onChange={(e) => handleInputChange("tare_mass", e.target.value)}
              rows={4}
            />
          </div>
          <div className="topSix-inner">
            <h5>19 Total Gross Mass (kg)</h5>
            <Input
              value={formData.total_gross_mass}
              onChange={(e) =>
                handleInputChange("total_gross_mass", e.target.value)
              }
              rows={4}
            />
          </div>
        </div>
        <div className="topSeven">
          <div className="topSeven-left">
            <h5>Container/Vehicle Packing Certificate</h5>
            <p>
              I hereby declare that the goods described above have been
              packed/loaded into the container/vehicle identified above in
              accordance with the applicable provisions
            </p>
          </div>
          <div className="topSeven-right">
            <h5> 21 Receiving Organization Receipt</h5>
            <p>
              Received the above number of packages/containers/trailers in
              apparent good order and condition, unless stated hereon: RECEIVING
            </p>
            <h5> ORGANIZATION REMARKS:</h5>
          </div>
        </div>
        <div className="topEight">
          <div className="topEight-inner">
            <h5>20 Name of Company</h5>
            <Input
              value={formData.name_of_company}
              onChange={(e) => handleInputChange("name_of_company", e.target.value)}
              rows={4}
            />
          </div>
          <div className="topEight-inner">
            <h5>21 Hauler's Name</h5>
            <Input
              value={formData.haulers_name}
              onChange={(e) => handleInputChange("haulers_name", e.target.value)}
              rows={4}
            />
          </div>
          <div className="topEight-inner">
            <h5>22 Name of Company Preparing Note</h5>
            <Input
              value={formData.name_of_company_preparing_note}
              onChange={(e) =>
                handleInputChange("preparingNoteCompany", e.target.value)
              }
              rows={4}
            />
          </div>
        </div>
        <div className="topEight">
          <div className="topEight-inner">
            <h5>Name/Status of Declarant Note</h5>
            <Input
              value={formData.name_status_declarant_note_1}
              onChange={(e) => handleInputChange("name_status_declarant_note_1", e.target.value)}
              rows={4}
            />
          </div>
          <div className="topEight-inner">
            <h5>Vehicle Registration No.</h5>
            <Input
              value={formData.vehicle_registration_no}
              onChange={(e) =>
                handleInputChange("vehicle_registration_no", e.target.value)
              }
              rows={4}
            />
          </div>
          <div className="topEight-inner">
            <h5>Name/Status of Declarant</h5>
            <Input
              value={formData.name_status_declarant_note_2}
              onChange={(e) =>
                handleInputChange("name_status_declarant_note_2", e.target.value)
              }
              rows={4}
            />
          </div>
        </div>
        <div className="topEight">
          <div className="topEight-inner">
            <h5>Place and Date</h5>
            <Input
              value={formData.place_and_date_1}
              onChange={(e) =>
                handleInputChange("place_and_date_1", e.target.value)
              }
              rows={4}
            />
          </div>
          <div className="topEight-inner">
            <h5>Driver Name and Date</h5>
            <Input
              value={formData.driver_name_and_date}
              onChange={(e) =>
                handleInputChange("driver_name_and_date", e.target.value)
              }
              rows={4}
            />
          </div>
          <div className="topEight-inner">
            <h5>Place and Date</h5>
            <Input
              value={formData.place_and_date_2}
              onChange={(e) =>
                handleInputChange("place_and_date_2", e.target.value)
              }
              rows={4}
            />
          </div>
        </div>
        <div className="topEight">
          <div className="topEight-inner">
            <h5>Signature of Declarant</h5>
          </div>
          <div className="topEight-inner">
            <h5>Driver's Signature</h5>
          </div>
          <div className="topEight-inner">
            <h5>Signature of Declarant</h5>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "12px",
          gap: "12px",
          width: "900px",
        }}
      >
        <Space>
          <Link to={"/operations/loadings/imo"}>
            <Button
              style={{ backgroundColor: "#36404E", color: "white" }}
              loading={loading}
            >
              Back
            </Button>
          </Link>
          <Button
            style={{ backgroundColor: "#C62737", color: "white" }}
            onClick={handleUpdate}
            loading={loading}
          >
            {isAdd ? 'Add' : "Update"}
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default ImoEdit;
